import { createBrowserHistory } from 'history';

type APP_ENV = 'local' | 'feat' | 'dev' | 'test' | 'stag' | 'canary' | 'prod';

const envs = ['localhost', 'feat', 'dev', 'test', 'stag', 'canary', 'prod'];
const subdomainSplit = window.location.hostname.split('.')[0].split('-');
const envSuffix = subdomainSplit[subdomainSplit.length - 1];
const currentEnv = envs.includes(envSuffix) ? envSuffix : 'prod';

const getCustomer = () => {
  const mapping = (window as any).domainCustomerMap.find(mapping => {
    return window.location.hostname.indexOf(mapping.domain) !== -1;
  });
  return mapping ? mapping.customer : window.location.hostname.split('.')[0];
};

let customer = getCustomer();
let url = `https://${window.location.hostname}`;

// TODO: remove these
let primaryColor = '#408BA8';
let secondaryColor = '#FC783D';
let logo = 'https://www.gredi.fi/wp-content/themes/gredi/img/gredi_logo.png';

// Proxy API requests through NGINX ingress running on Docker Compose
const apiProxyEnabled = false;

if (
  window.location.hostname === 'localhost' &&
  window.location.protocol === 'http:'
) {
  url = 'http://localhost:8080';
  // url = 'https://newtest.materialbank.net';
  customer = 'peruspalvelu';
} else if (window.location.hostname === 'localhost' && apiProxyEnabled) {
  url = 'https://localhost:44351';
  customer = 'peruspalvelu';
} else if (
  window.location.hostname === 'localhost' ||
  window.location.hostname === 'gredi-contenthub-dev.taitodev.com' ||
  window.location.hostname === 'newtest.materialbank.net'
) {
  url = 'https://newtest.materialbank.net';
  customer = 'peruspalvelu';
} else if (
  window.location.hostname === 'gredi-contenthub-test.taitodev.com' ||
  window.location.hostname === 'convertor.materialbank.net'
) {
  url = 'https://convertor.materialbank.net';
  customer = 'GreDi';
} else if (window.location.hostname === 'gredi-contenthub-stag.taitodev.com') {
  url = 'https://convertor.materialbank.net';
  customer = 'finlandia';
  primaryColor = '#032E56';
  secondaryColor = '#9B2437';
  logo =
    'https://seeklogo.com/images/F/Finlandia_Vodka-logo-A02B5E792B-seeklogo.com.png';
} else if (
  window.location.hostname === 'gredi-contenthub-prod.taitodev.com' ||
  window.location.hostname === 'nibo3convertor.materialbank.net'
) {
  url = 'https://nibo3convertor.materialbank.net';
  customer = 'DIME';
  primaryColor = '#002F88';
  secondaryColor = '#65BA30';
  logo =
    'https://neste.contenthub.fi/NiboWEB/DIME/getPublicFile.do?uuid=8571747&ticket=8523822041f7dbb258c90d2b89487c9c&type=original';
}

const getBaseHref = () => {
  return document.getElementsByTagName('base')[0].getAttribute('href');
};

const getPathShareKey = () => {
  const match = window.location.pathname.match(
    new RegExp(
      `^${getBaseHref()}(?:customers/[^/]*/)?shares/([^/]+/[^/]+/[^/]+)/.*`
    )
  );
  return match ? match[1].split('/') : null;
};

const getPathPrefix = () => {
  const shareKey = getPathShareKey();
  const customer = getCustomerOnPath();
  const sharePath = shareKey
    ? `shares/${shareKey[0]}/${shareKey[1]}/${shareKey[2]}/`
    : '';
  const customerPath = customer ? `customers/${customer}/` : '';
  return `${getBaseHref()}${customerPath}${sharePath}`;
};

const getCustomerOnPath = () => {
  const match = window.location.pathname.match(
    new RegExp(`^${getBaseHref()}customers/([^/]*)`)
  );
  return match ? match[1] : null;
};

export const history = createBrowserHistory({
  basename: getPathPrefix().substring(0, getPathPrefix().length - 1),
});

const config = {
  ENV: currentEnv as APP_ENV,
  IS_DEV: process.env.NODE_ENV !== 'production',
  CURR_BASE_URL:
    'https://' +
    window.location.hostname +
    (window.location.port && window.location.port !== '443'
      ? ':' + window.location.port
      : ''),
  BASE_URL: url,
  API_URL: `${url}/api/v1`,
  SENTRY_PUBLIC_DSN: process.env.SENTRY_PUBLIC_DSN as string,
  ERROR_REPORTING_ENABLED:
    currentEnv === 'prod' &&
    process.env.NODE_ENV === 'production' &&
    !!process.env.SENTRY_PUBLIC_DSN &&
    process.env.SENTRY_PUBLIC_DSN.startsWith('https'),

  BURNER_URL: 'https://taito-ffmpeg-proto-dev.taitodev.com/api',

  apiUrl: `${url}/api/v1`,
  basePath: getBaseHref(),
  assetsPath: getBaseHref(),
  pathPrefix: getPathPrefix(),
  shareKey: getPathShareKey(),

  customer: getCustomerOnPath() || customer,
  url,
  theme: {},

  // TODO: remove these hardcoded settings
  primaryColor,
  secondaryColor,
  logo,
};

export default config;
